// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {Settings} from "../book/Settings";
import {AppState} from "../store/AppStore";

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: Settings.backEndBaseUrl() + '/',
        prepareHeaders: (headers, {getState}) => {
            const gs = getState as () => AppState;
            if (gs().userState.token) {
                headers.set("Authorization", `Bearer ${gs().userState.token}`)
            }
            return headers
        },
        responseHandler: (response) => {
            if (response.url.endsWith("/api/v1/product/export")) {
                return response.blob();
            }

            return response.json();
        }
    }),
    endpoints: () => ({}),
    keepUnusedDataFor: 0
})